module.exports = __webpack_public_path__ + "static/apple_store_badge-21a06801491eb957375118d35a95ea2e.svg";